import { useMutation } from '@betterment/js-runtime';

import { AgentConfig } from './useSessionState';

import { urlBuilder } from '../../Shared/urlBuilder';

type Params = {
  inputText: string;
  agentConfig: AgentConfig;
  sessionId: string;
};

export const useSendMessage = () =>
  useMutation<{ message: string }, Params>(urlBuilder.apiV2AgentsPlayground.absolute(), { method: 'post' });
